import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import useAppData from 'app/services/hooks/useAppData'
import Button from 'components/core/Button/Button'
import styles from './Footer.module.scss'

/**
 * The `Footer`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Footer (props) {
  const appData = useAppData()
  const socialLinks = useMemo(() => appData?.global?.social, [])

  return (
    <div className={styles.footer}>
      {socialLinks.map(({ icon, title, url }, i) => (
        <Button
          Tag="a"
          key={i}
          color="c"
          size="small"
          type="symbol"
          icon={icon}
          title={title}
          href={url}
          target="_blank"
        />
      ))}
    </div>
  )
}

/** @type {object} */
Footer.propTypes = {
  temp: PropTypes.string
}

/** @type {object} */
Footer.defaultProps = {}

// Memoize
export default memo(Footer)
